import { cn } from "@/lib/utils";
import type { DashboardLabels, DashboardStat } from "./types";
import { DashboardKpiCard } from "./DashboardKpiCard";

export interface DashboardKpiGridProps {
  stats: DashboardStat[];
  labels: DashboardLabels;
  className?: string;
}

export function DashboardKpiGrid({ stats, labels, className }: DashboardKpiGridProps) {
  return (
    <div
      className={cn(
        "grid gap-3",
        "grid-cols-2 md:grid-cols-3 xl:grid-cols-6",
        className,
      )}
    >
      {stats.map((stat, i) => {
        const meta = labels.stats[stat.labelKey] ?? { label: stat.labelKey, compare: "" };
        return (
          <DashboardKpiCard
            key={stat.key}
            stat={stat}
            label={meta.label}
            compareLabel={meta.compare}
            index={i}
          />
        );
      })}
    </div>
  );
}
